import type { KeyPose } from "./KeyPose";

export class KeyMotion {
	readonly pose: KeyPose = { depth: 0, x: 0, y: 0 };

	readonly target: KeyPose = { depth: 0, x: 0, y: 0 };

	private readonly velocity: KeyPose = { depth: 0, x: 0, y: 0 };

	snap(): void {
		Object.assign(this.pose, this.target);
		this.velocity.depth = 0;
		this.velocity.x = 0;
		this.velocity.y = 0;
	}

	step(deltaMs: number): boolean {
		// Bound catch-up after a stalled frame and substep the stiff switch spring.
		const elapsed = Math.min(deltaMs, 32) / 1000;
		const steps = Math.max(1, Math.ceil(elapsed * 480));
		const dt = elapsed / steps;
		for (let step = 0; step < steps; step++) {
			for (const axis of ["depth", "x", "y"] as const) {
				const stiffness = axis === "depth" ? 10000 : 6400;
				const damping = axis === "depth" ? 140 : 112;
				const acceleration =
					(this.target[axis] - this.pose[axis]) * stiffness -
					this.velocity[axis] * damping;
				this.velocity[axis] += acceleration * dt;
				this.pose[axis] += this.velocity[axis] * dt;
			}
			// The switch has hard travel stops; only its angular play can overshoot neutral.
			if (this.pose.depth < 0 || this.pose.depth > 1) {
				this.pose.depth = Math.max(0, Math.min(1, this.pose.depth));
				this.velocity.depth = 0;
			}
		}

		const moving = (["depth", "x", "y"] as const).some(
			(axis) =>
				Math.abs(this.target[axis] - this.pose[axis]) > 0.0001 ||
				Math.abs(this.velocity[axis]) > 0.001,
		);
		if (!moving) {
			this.snap();
		}
		return moving;
	}
}
